<script setup>
import PasswordResetForm from '../common/PasswordResetForm.vue'
import { useAuthStore } from '@/store/auth'
const auth = useAuthStore()
useHead({ title: '비밀번호 재설정 · TECHEDU' })
</script>
<template><PasswordResetForm :client="auth.client" area="user" login-path="/login" /></template>
